import axios from 'axios';
import { CombinableFilter } from 'bindings/reports/generic/CombinableFilter';
import { Target } from 'bindings/reports/generic/Target';
import { UpdatedField } from './web-types/api';
import type { GoalEvolutionCalculus } from './generic/action';
import { URL_FOUNDATION } from '../../config/keys';

export async function getReports(): Promise<Report[]> {
	return axios
		.get(`${URL_FOUNDATION}/api/v2/reports/generic`)
		.then(res => res.data);
}

interface PutReport {
	name?: string;
	value?: ReportValue;
	goals_options?: UpdatedField;
}

export function putReport(id: number, body: PutReport): Promise<Report> {
	return axios.put(`${URL_FOUNDATION}/api/v2/reports/generic/${id}`, body);
}

export function getReportById(id: number): Promise<Report> {
	return axios
		.get(`${URL_FOUNDATION}/api/v2/reports/generic/${id}`)
		.then(res => res.data);
}

export interface Report {
	id: number;
	name: string;
	value: ReportValue;
	updated_at: string;
	created_by: number;
	report_group_id: number;
	// null for reports whose goal options were never configured
	goals_options: GoalsOptions | null;
}

export interface GoalsOptions {
	evolution_calculus?: GoalEvolutionCalculus | null;
	show_delta?: boolean;
	weight_by_ref?: boolean;
}

export interface ReportValue {
	group_by: string;
	new_group_by?: number;
	panels: Panel[];
	range: Range;
	variation?: boolean;
	evolution?: string;
	filter?: { formatted: CombinableFilter<Target> };
	hiddenFilters?: boolean
}

interface Panel {
	columns: Column[];
	name?: string;
	products?: string[];
}

interface Column {
	Field?: Field;
	Computed?: Computed;
}

interface Field {
	aggregation: string;
	id: number;
	name?: string;
	operation?: string;
}

interface Computed {
	denominator: string;
	name: string;
	numerator: Numerator;
	percentage: boolean;
}

interface Numerator {
	Field: Field;
}

interface Range {
	begin: string;
	end: string;
}
